import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/jadwal-buka-puasa/$kota")({
  component: () => <Outlet />,
});